import { Text, Stack, Spinner } from '@chakra-ui/react';

function formatStat(stat: number) {
  return new Intl.NumberFormat('sv-SE', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(stat);
}

interface SpeculatorStatCardProps {
  value?: number;
  label: string;
}

export function SpeculatorStatCard({ value, label }: SpeculatorStatCardProps) {
  const isLoading = value === undefined;
  const displayValue = value === 0 ? 'Inga' : value ? formatStat(value) : '';

  return (
    <Stack
      backgroundColor="transparent"
      borderWidth="1px"
      borderColor="blackAlpha.100"
      rounded="4px"
      justifyContent="center"
      alignItems="center"
      h="156px" // Fixed height needed for mobile view
      px={{ mobile: 1, desktop: 4 }}
    >
      {isLoading ? (
        <Spinner size="md" color="blackAlpha.400" />
      ) : (
        <Text size="4xl" fontWeight="medium">
          {displayValue}
        </Text>
      )}
      <Text size="sm" color="blackAlpha.700" textAlign="center">
        {label}
      </Text>
    </Stack>
  );
}
